/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import React, { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormOnEditGroup from "./FormOnEditGroup";
import FormOnGroup from "./FormOnGroup";
import TableOnGroups from "./TableOnGroup";

const Group = (props) => {
    const BaseUrl = `${url.group}`
    const fetchData = useContext(FetchDataContext);
    const { getDataTables, addData, updateData, tableRef } = fetchData;

    const [state, setState] = useState({
        openAdd: false,
        pageSize: 5,
    });
    const { openAdd, pageSize } = state;
    const [openEdit, setOpenEdit] = useState(false);
    const [data, setData] = useState();

    const handleOpenCloseFormAdd = () => {
        setState({ ...state, openAdd: !openAdd });
    };

    const handleOpenCloseFormEdit = (params) => {
        setOpenEdit(!openEdit);
        setData(params);
    };

    const fetchAPI = async (action, data) => {
        let result;
        if (action === 'add') result = await addData(`${BaseUrl}/add_group`, data, handleOpenCloseFormAdd)
        if (action === 'edit') result = await updateData(`${BaseUrl}/edit_group?id=${data.id}`, data, handleOpenCloseFormEdit)
        return result
    }

    return (
        <Grid direction="column" alignItems="center">
            <TableOnGroups
                getDataTables={getDataTables}
                BaseUrl={BaseUrl}
                pageSize={pageSize}
                tableRef={tableRef}
                modalAdd={handleOpenCloseFormAdd}
                modalEdit={handleOpenCloseFormEdit}
            />
            <FormOnGroup
                fetchAPI={fetchAPI}
                open={openAdd}
                handleClose={handleOpenCloseFormAdd}
            />
            <FormOnEditGroup
                fetchAPI={fetchAPI}
                open={openEdit}
                editData={data}
                handleClose={handleOpenCloseFormEdit}
            />
        </Grid>
    );
};
export default Group;
